import React, { Component } from 'react';
import {ChevronRight} from 'lucide-react';
import '../css/project-read-more-button.css';
import { LanguageContext } from '../contexts/LanguageContext';

class ProjectReadMoreButton extends Component {
    static contextType = LanguageContext
    
    render() { 
        const { translations } = this.context;
        return (
            <button 
                className='readMoreButton' 
                onClick={this.props.onClick}
            >
                {translations?.projects_read_more_button_text} <ChevronRight size={22}/>
            </button>
        );
    }
}
 
export default ProjectReadMoreButton;